import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Plane, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminReset() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token: token.trim(), password });
      toast.success("Password updated. Please sign in.");
      nav("/admin/login");
    } catch (err) { toast.error(err.response?.data?.detail || "Reset failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0B3C5D] flex items-center justify-center px-4">
      <form onSubmit={submit} className="bg-white rounded-3xl p-8 w-full max-w-sm shadow-2xl">
        <div className="flex items-center gap-2 mb-6">
          <span className="w-10 h-10 rounded-xl bg-[#0B3C5D] flex items-center justify-center"><Plane className="w-5 h-5 text-[#FF6B35]" /></span>
          <span className="font-display font-extrabold text-lg text-[#0B3C5D]">Elia Admin</span>
        </div>
        <h1 className="font-display text-2xl font-bold text-slate-900">Reset password</h1>
        <p className="text-slate-500 text-sm mb-6">Paste the code from your email and set a new password.</p>
        <div className="space-y-4">
          <div><Label>Reset code</Label><Input data-testid="reset-token" required value={token} onChange={(e) => setToken(e.target.value)} /></div>
          <div><Label>New password</Label><Input data-testid="reset-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} /></div>
          <Button data-testid="reset-submit" disabled={loading} className="w-full rounded-full bg-[#FF6B35] hover:bg-[#e85a26] text-white font-semibold py-6">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Update password"}
          </Button>
        </div>
      </form>
    </div>
  );
}
